export const headerQueryKeys = {
  prepareReanalyze: (hashes: string[], skipRlcs: boolean) => [
    "prepareReanalyze",
    ...(hashes ?? []),
    skipRlcs
  ]
};
